<template>
    <div class="page">
        <div class="shade" v-if="!start || popups"></div>
        <div class="popups" v-if="popups">
            <Input placeholder="手机号" v-model="hm" style="width: 300px">
            <span slot="prepend">手机号：</span>
            </Input>
            <Button type="success" class="btn-c s1" @click="dialOutOk">确定</Button>
            <Button class="btn-c s2" @click="dialOutClose">取消</Button>
        </div>
        <div class="p-l">
            <span class="p-l-t">坐席</span>
            <div class="p-l-b">[ {{ start ? '已开启' : '未开启' }} ]</div>
        </div>
        <div class="p-r">
            <div class="p-r-t">
                <div class="p-r-t-t">
                    <Button type="info" size="small" :class="{active: ready}" @click="handleReady">就绪</Button>
                    <Button type="info" size="small" :class="{active: xxx}" @click="handleFunc">处理</Button>
                    <span class="info-btn-all">
                        <Button type="info" size="small" :class="{active: ddd}">{{stateTitle}}</Button>
                        <div :class="['a-ms', {wz: state === 3}]">
                            <div @click="stateSelectedFunc(1)">小休</div>
                            <div @click="stateSelectedFunc(2)">就餐</div>
                            <div @click="stateSelectedFunc(3)" class="a-ms-l">洗手间</div>
                            <div @click="stateSelectedFunc(4)">培训</div>
                            <div @click="stateSelectedFunc(5)">会议</div>
                        </div>
                    </span>
                    <div class="c-l">
                        <iSwitch size="small" v-model="noAw" @on-change="remarkNoFunc"></iSwitch>
                        <span class="l-1">无话后处理</span>
                    </div>
                    <div class="b-r">
                        <Button type="info" size="small" @click="historyFunc">通话记录</Button>
                    </div>
                </div>
                <div class="p-r-t-b">
                    <Button type="info" size="small" v-for="k in btns" :key="k" class="lx" @click="clickFunc(k)">{{cfgs[k] || ''}}</Button>
                </div>
            </div>
            <div class="p-r-b">
                <div class="p-r-b-l">
                    <span class="label">客户号码:</span>
                    {{phone}}
                </div>
                <div class="p-r-b-m">
                    <span class="label">通话时长:</span>
                    {{callTime}}
                </div>
                <div class="p-r-b-r">
                    <span class="label">转接时长:</span>
                    {{tranTime}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "page",
    data () {
        return {
            // 是否启动完成
            start: true,
            // 就绪
            ready: false,
            xxx: false,
            ddd: false,
            // 是否弹出外呼
            popups: false,
            // 坐席状态，0离席
            state: 0,
            // 操作按钮
            btns: ["dialOut", "dialAgent"],
            // 显示电话
            phone: "",
            // 外呼电话
            hm: "",
            // 通话时长 ms
            call: 0,
            // 转接时长 ms
            tran: 0,
            // 功能名称配置
            cfgs: {
                dialOut: "外呼",
                dialThird: "取号外拨",
                conference: "会议",
                dialAgent: "拨坐席",
                answer: "接听",
                drop: "挂断",
                hold: "保持",
                retrieve: "取回",
                consultation: "坐席转移",
                satisfaction: "满意度",
                alternate: "切换",
                transfer: "完成转移",
                completeConference: "完成会议",
                bargeIn: "强插",
                forceBreak: "强拆",
                intercept: "拦截"
            },
            opName: "",
            noAw: true,
            recordTimer: 0,
            initRecordTime: 0,
            transferTimer: 0,
            initTransferTime: 0,
            userData: {}
        };
    },
    computed: {
        // 转接时长
        callTime () {
            return this.formatTime(this.call);
        },
        // 通话时长
        tranTime () {
            return this.formatTime(this.tran);
        },
        // 状态名称
        stateTitle () {
            return ["离席", "小休", "就餐", "洗手间", "培训", "会议"][this.state];
        }
    },
    methods: {
        handleReady () {
            this.ReadyOP();
        },
        // 状态
        stateSelectedFunc (v) {
            //this.state = v
            this.NotReadyOP(v);
        },
        // 处理
        handleFunc () {
            this.AfterCallWorkOP();
        },
        // 点击
        clickFunc (k) {
            if (this[k]) this[k]();
        },
        // 时间转换
        formatTime (seconds) {
            return `${Math.floor((seconds / 1000 / 60 / 60) % 24)}时${Math.floor(
                (seconds / 1000 / 60) % 60
            )}分${Math.floor((seconds / 1000) % 60)}秒`;
        },
        //开始通话计时
        StratCalltiming () {
            if (this.recordTimer == 0) {
                this.initRecordTime = -1000;
                this.recordTimer = setInterval(this.Calltiming, 1000);
            }
        },
        //开始转接计时
        StartTransfertiming () {
            if (this.transferTimer == 0) {
                this.initTransferTime = -1000;
                this.transferTimer = setInterval(this.Transfertiming, 1000);
            }
        },
        //结束通话计时
        EndCalltiming () {
            clearInterval(this.recordTimer);
            this.recordTimer = 0;
            this.initRecordTime = 0;
        },
        //结束转接计时
        EndTransfertiming () {
            clearInterval(this.transferTimer);
            this.transferTimer = 0;
            this.initTransferTime = 0;
        },
        //通话计时方法
        Calltiming () {
            this.initRecordTime = this.initRecordTime + 1000;
            this.call = this.initRecordTime;
        },
        //转接计时方法
        Transfertiming () {
            this.initTransferTime = this.initTransferTime + 1000;
            this.tran = this.initTransferTime;
        },
        // 通话记录
        historyFunc () {
            this.OpenRecordOP();
        },
        // 无话
        remarkNoFunc (b) {
            let data = {
                key: "ChangeIsHaveRestTime",
                nowIsHaveRest: b
            };
            this.SendMessageToGenesysy(data);
        },
        // 外呼
        dialOut () {
            this.opName = "dia";
            this.popups = true;
        },
        dialThird () {
            this.opName = "third";
            this.popups = true;
        },
        conference () {
            this.opName = "meeting";
            this.popups = true;
        },
        // 外呼取消
        dialOutClose () {
            this.hm = "";
            this.popups = false;
        },
        dialAgent () {
            this.OpenSkillOP(1);
        },
        consultation () {
            this.OpenSkillOP(2);
        },
        //强插
        bargeIn () {
            let data = {
                key: "bargeIn"
            };
            this.SendMessageToGenesysy(data);
        },
        //强拆
        forceBreak () {
            let data = {
                key: "forceBreak"
            };
            this.SendMessageToGenesysy(data);
        },
        //拦截
        intercept () {
            let data = {
                key: "RequestIntercept"
            };
            this.SendMessageToGenesysy(data);
        },
        // 外呼确定
        dialOutOk () {
            if (this.hm == "") {
            } else {
                if (this.opName == "dia") {
                    this.MakeCallOP(this.hm);
                } else if (this.opName == "third") {
                    this.DialThirdOP(this.hm);
                } else if (this.opName == "meeting") {
                    this.InitiateConferenceOP(this.hm);
                }
            }
            this.phone = this.hm;
            this.hm = "";
            this.popups = false;
        },
        SendMessageToGenesysy (msg) {
            if (this.$socket.connected) {
                //console.log("发送消息")
                if(msg && msg.key && msg.key == 'makeCall' && msg.userData)
                {
                    this.userData = msg.userData
                }
                this.$socket.emit("Receive_Genesys_Msg", msg);
            } else {
                    let msg = {
                    EventName: "NoClient",
                    EventCode: 1,
                    EventMessage: "未检测到客户端，正在尝试重连..."
                };
                this.SendMessageToPage(msg);
                //console.log("不要发送消息")
                window.location.reload()
            }
        },
        SendMessageToPage (data) {
            window.parent.postMessage(data, "*");
        },
        TestHello () {
            let data = {
                key: "helloWorld"
            };
            this.SendMessageToGenesysy(data);
        },
        // 拨打
        MakeCallOP (num) {
            let data = {
                // 1.普通(自动匹配是否+90或者9), 2.是否加0用户自定义, 3.完全用户自定义拨打
                callType: 3,
                key: "makeCall",
                number: num
            };
            this.SendMessageToGenesysy(data);
        },
        // 挂断
        drop () {
            let data = {
                key: "releaseCall"
            };
            this.SendMessageToGenesysy(data);
        },
        // 接听
        answer () {
            let data = {
                key: "answerCall"
            };
            this.SendMessageToGenesysy(data);
        },
        // 取号外拨
        DialThirdOP (num) {
            let data = {
                key: "dialThird",
                number: num
            };
            this.SendMessageToGenesysy(data);
        },
        // 完成转移
        transfer () {
            let data = {
                key: "completeTransfer"
            };
            this.SendMessageToGenesysy(data);
        },
        // 会议
        InitiateConferenceOP (num) {
            let data = {
                key: "initiateConference",
                number: num
            };
            this.SendMessageToGenesysy(data);
        },
        // 完成会议
        completeConference () {
            let data = {
                key: "completeConference"
            };
            this.SendMessageToGenesysy(data);
        },
        // 切换电话
        alternate () {
            let data = {
                key: "swapCall"
            };
            this.SendMessageToGenesysy(data);
        },
        // 保持
        hold () {
            let data = {
                key: "holdCall"
            };
            this.SendMessageToGenesysy(data);
        },
        // 取回
        retrieve () {
            let data = {
                key: "retrieveCall"
            };
            this.SendMessageToGenesysy(data);
        },
        // 打开技能组界面 agentType: 1.呼叫列表 2.转接列表
        OpenSkillOP (agentType) {
            let data = {
                key: "openSkill",
                agentType: agentType
            };
            this.SendMessageToGenesysy(data);
        },
        // 满意度
        satisfaction () {
            let data = {
                key: "satisfaction"
            };
            this.SendMessageToGenesysy(data);
        },
        // 就绪
        ReadyOP () {
            let data = {
                key: "ready"
            };
            this.SendMessageToGenesysy(data);
        },
        // 话后处理
        AfterCallWorkOP () {
            let data = {
                key: "afterCallWork"
            };
            this.SendMessageToGenesysy(data);
        },
        // 离席
        NotReadyOP (reason) {
            let data = {
                key: "notReady",
                reason: reason
            };
            this.SendMessageToGenesysy(data);
        },
        // 打开通话记录
        OpenRecordOP (reason) {
            let data = {
                key: "openRecord",
                reason: reason
            };
            this.SendMessageToGenesysy(data);
        },
        // 获取是否话后处理状态
        GetIsHaveRestTime () {
            let data = {
                key: "getIsHaveRestTime"
            };
            this.SendMessageToGenesysy(data);
        },
        // 处理客户端返回的信息
        DealClientInfo (msg) {
            let isReturn = false;
            switch (msg.EventName) {
                case "ChangeButton":
                    this.btns = msg.BtnArray;
                    break;
                case "ChangeState":
                    if (msg.AgentState == "NotReady") {
                        this.state = msg.reason;
                        this.ddd = true;
                        this.ready = false;
                        this.xxx = false;
                    } else if (msg.AgentState == "Ready") {
                        this.ddd = false;
                        this.ready = true;
                        this.xxx = false;
                    } else if (msg.AgentState == "AfterCallWork") {
                        this.ddd = false;
                        this.ready = false;
                        this.xxx = true;
                    }
                    break;
                case "GetIsHaveRestTime":
                    if (msg.IsHaveRestTime == true) {
                        this.noAw = false;
                    } else {
                        this.noAw = true;
                    }
                    break;
                case "Established":
                    this.StratCalltiming();
                    isReturn = true;
                    break;
                case "ReleaseCall":
                    this.EndCalltiming();
                    this.EndTransfertiming();
                    break;
                case "InitTransfer":
                    this.StartTransfertiming();

                    break;
                case "CompleteTransfer":
                    this.EndTransfertiming();
                    break;
                case "PrintNum":
                    this.ddd = false;
                    this.ready = false;
                    this.xxx = false;
                    this.phone = msg.PhoneNumber;
                    break;
                default:
                    isReturn = true;
                    break;
            }
            return isReturn;
        }
    },
    sockets: {
        disconnect () {
            this.start = false;
        },
        reconnect () {
            this.btns = [""];
        },
        reconnecting () {
            let msg = {
                EventName: "NoClient",
                EventCode: 1,
                EventMessage: "客户端未打开!"
            };
            //this.SendMessageToPage(msg);
            this.start = false;
        },
        // 接收Genesys客户端反馈消息
        message (msg) {
            if (this.DealClientInfo(msg)) {
                if(msg && msg.EventName)
                {
                    if(msg.EventName == 'RequestMakeCall' || msg.EventName == 'Established')
                    {
                        msg['userData'] = this.userData;
                    }
                }
                this.SendMessageToPage(msg);
            }
        }
    },
    mounted () {
        this.$socket.io._reconnectionAttempts = 2;
        //window.setTimeout(this.TestHello, 1000);
        window.addEventListener(
            "message",
            event => {
                if (event && event.data && event.data.appId) {
                    this.SendMessageToGenesysy(event.data);
                } else {
                    let msg = {
                        EventCode: 0,
                        EventMessage: "发送请求参数不正确!"
                    };
                    this.SendMessageToPage(msg);
                }
            },
            false
        );
        //window.setTimeout(this.GetIsHaveRestTime, 1200);
    }
};
</script>

<style>
.page {
    position: relative;
    width: 542px;
    height: 70px;
    box-sizing: border-box;
    background: #89c8bd;
    color: #fff;
}
.shade {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background: #fff;
    opacity: 0.5;
}
.popups {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 150;
    padding: 19px 50px;
}
.btn-c.s1 {
    position: absolute;
    top: 19px;
    left: 356px;
}
.btn-c.s2 {
    position: absolute;
    top: 19px;
    left: 418px;
}
.ivu-input-group-append,
.ivu-input-group-prepend,
.ivu-input,
.ivu-btn {
    border-radius: 0 !important;
}
.p-l {
    position: absolute;
    left: 0;
    height: 70px;
    width: 86px;
    border-right: 1px solid #777;
    box-sizing: border-box;
    background: #18b294;
}
.p-l-t {
    font-size: 24px;
    position: relative;
    top: 6px;
}
.p-l-b {
    font-size: 13px;
    position: relative;
    top: 3px;
}
.p-r {
    position: absolute;
    right: 0;
    height: 70px;
    width: 456px;
    box-sizing: border-box;
}
.p-r-t {
    position: absolute;
    top: 0;
    height: 52px;
    width: 100%;
    border-top: 1px solid #777;
    border-bottom: 1px solid #777;
    border-right: 1px solid #777;
    box-sizing: border-box;
}
.p-r-b {
    position: absolute;
    bottom: 0;
    height: 18px;
    width: 100%;
    box-sizing: border-box;
    line-height: 18px;
    background: linear-gradient(#18b294, #89c8bd);
    border-right: 1px solid #777;
    border-bottom: 1px solid #777;
}
.p-r-b-l,
.p-r-b-m,
.p-r-b-r {
    width: 151px;
    float: left;
    height: 100%;
    font-size: 12px;
}
.p-r-t-t {
    position: absolute;
    width: 100%;
    height: 26px;
    line-height: 25px;
    top: 0;
    text-align: left;
    padding: 0 4px;
    user-select: none;
}
.p-r-t-b {
    position: absolute;
    width: 100%;
    height: 26px;
    line-height: 23px;
    bottom: 0;
    text-align: left;
    padding: 0 4px;
}
.label {
    font-weight: bold;
    color: #495060;
    user-select: none;
}
.ivu-btn-small {
    padding: 0px 7px !important;
}
.ivu-btn-info {
    background: #18b294 !important;
    border-color: #777 !important;
}
.b-r {
    height: 100%;
    position: absolute;
    right: 4px;
    top: 0;
}
.c-l {
    margin-left: 4px;
    position: absolute;
    height: 100%;
    top: 0;
    left: 198px;
}
.c-l .l-1 {
    position: relative;
    top: 1px;
    left: 2px;
}
.ivu-switch-checked {
    border-color: #18b294 !important;
    background-color: #18b294 !important;
}
.ivu-btn-info:hover {
    background-color: #89c8bd !important;
    border-color: #18b294 !important;
}
.ivu-btn-info.active {
    border-color: #18b294 !important;
    background: #fff !important;
    color: #19be6b !important;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2) !important;
}
.a-ms {
    position: absolute;
    width: 213px;
    height: 20px;
    background: #89c8bd;
    z-index: 5;
    top: 3px;
    left: 129px;
    border-radius: 0 3px 3px 0;
    border: 1px solid #777;
    border-left: 0;
    box-sizing: border-box;
}
.a-ms.wz {
    left: 141px;
}
.a-ms div {
    width: 40px;
    height: 100%;
    line-height: 18px;
    float: left;
    border-left: 1px solid #777;
    text-align: center;
    cursor: pointer;
}
.a-ms div:hover {
    background: #18b294;
}
.a-ms div.a-ms-l {
    width: 52px;
}
.info-btn-all .a-ms {
    display: none;
}
.info-btn-all:hover .a-ms {
    display: block;
}
.lx {
    margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue